import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IVw_Nagar_Khanda {
nagar_khanda_id:number,
nagar_khanda_name:string,
zilla_id:number,
seq_no:number,
is_active:number,
zilla_name:string,
vibhag_name:string
}

interface IVw_Nagar_KhandaData {
    list?: Array<IVw_Nagar_Khanda>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IVw_Nagar_KhandaData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const vw_nagar_khandaSlice = createSlice({
    name: "vw_nagar_khanda",
    initialState,
    reducers: {
        setVw_Nagar_KhandaList: (state, _action: PayloadAction<IVw_Nagar_KhandaData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetVw_Nagar_KhandaToInit: (state) => {
            state = initialState;
        },
        setVw_Nagar_KhandaMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setVw_Nagar_KhandaList, resetVw_Nagar_KhandaToInit, setVw_Nagar_KhandaMessage } = vw_nagar_khandaSlice.actions;

export default vw_nagar_khandaSlice.reducer;

